import React from 'react';
import { Column } from 'react-table';
import { concat } from 'ramda';
import { FormattedMessage } from 'react-intl';
import Highlighter from 'react-highlight-words';
import { formatDate } from './dateHelper';
import UserLogo from '../../components/UserLogo';
import Icon from '../../components/Icon';
import TextOverflowTooltip from '../../components/TextOverflowTooltip';

export const getPositionColumns = (search = '', simpleV = false): Column[] => {
  const requiredColumns: Column[] = [{
    Header: () => <FormattedMessage id="step1.title" defaultMessage="Position title" />,
    accessor: 'name',
    Cell: ({ row: { original } }: any) => (
      <div className="d-flex align-items-center">
        <span className="table-main-icon"><Icon icon="position" /></span>
        <TextOverflowTooltip content={original.name} width={180}>
          <Highlighter
            highlightClassName="highlighted-text"
            searchWords={search.split(' ')}
            textToHighlight={original.name}
            autoEscape
          />
        </TextOverflowTooltip>
      </div>
    )
  },
  {
    Header: () => <FormattedMessage id="step1.lastUseDate" defaultMessage="Date last used" />,
    accessor: 'lastUseDate',
    Cell: ({ cell: { value } }) => value && formatDate(value),
    width: simpleV ? 80 : 150
  }];

  const additionalColumns: Column[] = [{
    Header: () => <FormattedMessage id="step1.modifiedBy" defaultMessage="Last modified by" />,
    accessor: 'lastUsedBy',
    id: 'lastUsedBy',
    Cell: ({ cell: { value } }) => (value ? (
      <div className="d-flex align-items-center">
        <UserLogo user={value} />
        <span className="ml-2">{`${value.firstName} ${value.lastName}`}</span>
      </div>
    ) : null)
  },
  {
    Header: () => <FormattedMessage id="positionTable.activeCandidates" defaultMessage="Active candidates" />,
    accessor: 'activeCandidates',
    Cell: ({ cell: { value } }) => (
      <div style={{ maxWidth: '120px' }} className="table-center">
        <div className="circle-cell">
          {value}
        </div>
      </div>
    )
  }];

  return simpleV ? requiredColumns : concat(requiredColumns, additionalColumns);
};
